var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"has-modal-card":"","trap-focus":""},model:{value:(_vm.isActive),callback:function ($$v) {_vm.isActive=$$v},expression:"isActive"}},[_c('WorkoutLibrary',{staticClass:"modal-card box",attrs:{"selectionEnabled":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }